import { Switch } from 'antd'

import { useUserInfoStore } from '@/stores/user/userInfoStore'

import generalCn from '../GeneralFiltersStyles.module.scss'
import cn from './FilterWithToggle.module.scss'

type FilterWithTogglePropsType = {
  value: boolean
  title: string
  setValue: (value: boolean) => void
}

function FilterWithToggle(props: FilterWithTogglePropsType) {
  const { value, title, setValue } = props

  const { selectedOrganisation } = useUserInfoStore((state) => state)

  return (
    <div className={generalCn.filterContainer}>
      <div className={cn.filterContainerInner}>
        <div className={generalCn.filterName}>{title}</div>
        <div
          className={
            Object.keys(selectedOrganisation).length
              ? [cn.switch, cn.organisationSelected].join(' ')
              : cn.switch
          }
        >
          <Switch value={value} onChange={(value) => setValue(value)} />
        </div>
      </div>
    </div>
  )
}

export default FilterWithToggle
